import { Modal } from 'antd';
import { Col } from 'components/Box/Col';
import Button from 'components/Button';
import Text from 'components/Text';
import { forwardRef, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import successTick from '../../assets/tick-circle.svg';
import background from '../../assets/congratulation.svg';
import shopSelectors from 'services/shop/selectors';

export type FeedbackSuccessModalRef = {
  open: () => void;
};

type Props = {};

const FeedbackSuccessModal = forwardRef<FeedbackSuccessModalRef, Props>((props, ref) => {
  const [open, setOpen] = useState(false);
  const shopInfo = shopSelectors.getShopInfo();

  useImperativeHandle(ref, () => ({
    open: () => {
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
    
    if (shopInfo?.website) {
      window.location.href = shopInfo.website;
    }
  };

  return (
    <StyledModal
      open={open}
      onCancel={handleClose}
      title={null}
      footer={null}
      destroyOnClose
      width={400}
      closable={false}
      bodyStyle={{
        padding: 0,
      }}
    >
      <Success>
        <BoxIcon>
          <img src={successTick} alt='success' width={64} height={64} />
        </BoxIcon>
      </Success>
      <Content>
        <Text variant='H5'>Thank you!</Text>
        <Col gap='1'>
          <Text variant='CONTENT_2' weight='medium' textAlign='center'>
            We appreciate your feedback.
          </Text>
          <Text variant='CONTENT_1' color='text_3_v2' textAlign='center'>
            Your feedback helps us improve and provide the best experience.
          </Text>
        </Col>
      </Content>
      <Button ntype='CANCEL' onClick={handleClose} style={{ width: '100%' }}>
        Close
      </Button>
    </StyledModal>
  );
});

FeedbackSuccessModal.displayName = 'FeedbackSuccessModal';
export default FeedbackSuccessModal;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 32px 16px 16px;
    font-family: Mona Sans;

    .CONTENT_2 {
      font-size: 16px;
      font-family: Mona Sans;
    }
  }
`;

const Success = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url(${background});
  background-size: cover;
  padding-top: 16px;
`;

const BoxIcon = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 100px;
  background: #fff;
  border: 1px solid #ebfeff;
  box-shadow: 0 8px 100px 0 #c6faf2;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 24px 8px;
  margin-bottom: 32px;
`;
